import moment from 'moment';
import { APP_LOCAL_DATE_FORMAT, DEFAULT_MOMENT_FORMAT_VALUE } from '../../../../utils/Constant';
import { MA_LOAI_DOI_TUONG } from '../../../constants/Thuoc';

export const getPriceByObjectType = (drugData: any, objectTypeCode: string) => {
	const DRUG_OBJECT_TYPE_MAPPING = {
		[MA_LOAI_DOI_TUONG.BHYT]: 'bhytPrice',
		[MA_LOAI_DOI_TUONG.VIEN_PHI]: 'hospitalPrice',
		[MA_LOAI_DOI_TUONG.YEU_CAU]: 'servicePrice',
		[MA_LOAI_DOI_TUONG.VIP]: 'servicePrice',
	};
	return Number(drugData[DRUG_OBJECT_TYPE_MAPPING[objectTypeCode]] || 0);
};

export const getBirthdayDrugParam = (patientData: any) => {
	return moment([
		patientData.dobYear,
		patientData.dobMonth ? patientData.dobMonth - 1 : DEFAULT_MOMENT_FORMAT_VALUE.MONTH,
		patientData.dobDay ?? DEFAULT_MOMENT_FORMAT_VALUE.DAY,
	]).format(APP_LOCAL_DATE_FORMAT);
};
